// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"65ad09a5","952":"d396d5fd"}[chunkId] + ".chunk.js";
};